import {
  U21Button,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { RuleStatuses } from 'app/modules/rules/models';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled from 'styled-components';
import { RULE_STATUS_FRIENDLY_NAME } from 'app/modules/detectionModels/constants';

interface Props {
  id: number | string;
  title: string;
  status: RuleStatuses;
}

export const RuleTooltip = ({ id, title, status }: Props) => {
  return (
    <U21Spacer spacing={0}>
      <U21Spacer align="start" horizontal>
        <StyledTypography color="inherit" variant="body2">
          Name:
        </StyledTypography>
        <U21Typography breakWord color="inherit" variant="body2">
          {title}
        </U21Typography>
      </U21Spacer>
      <U21Spacer align="start" horizontal>
        <StyledTypography color="inherit" variant="body2">
          Status:
        </StyledTypography>
        <U21Typography color="inherit" variant="body2">
          {RULE_STATUS_FRIENDLY_NAME[status]}
        </U21Typography>
      </U21Spacer>
      <U21Spacer align="start" horizontal>
        <StyledTypography color="inherit" variant="body2">
          ID:
        </StyledTypography>
        <U21Spacer horizontal spacing={4}>
          <U21Typography color="inherit" variant="body2">
            {id}
          </U21Typography>
          <CopyToClipboard text={String(id)}>
            <U21Button variant="text" onClick={(e) => e.stopPropagation()}>
              Copy ID
            </U21Button>
          </CopyToClipboard>
        </U21Spacer>
      </U21Spacer>
    </U21Spacer>
  );
};

const StyledTypography = styled(U21Typography)`
  min-width: 50px;
  justify-content: flex-end;
`;
